import React, { useState, useCallback } from 'react';
import DatePicker from 'react-datepicker-legacy';
import moment, { Moment } from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles } from 'design-system/product/theme';
import { Button, Menu } from 'react-scale/components/design-system/product';

interface DateFilterProps {
  label: string;
  date?: Moment;
  format?: string;
  onChangeDate: (date: Moment | undefined) => void;
  maxDate?: Moment;
}

const DateFilter: React.FC<DateFilterProps> = ({
  label,
  date,
  format = 'YYYY-MM-DD',
  onChangeDate,
  maxDate,
}) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const handleOpen = useCallback((e: any) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  const handleClear = useCallback(() => {
    onChangeDate(undefined);
    handleClose();
  }, [onChangeDate, handleClose]);

  const handleChangeDate = useCallback(
    (newDate: Moment) => {
      onChangeDate(newDate);
      handleClose();
    },
    [handleClose, onChangeDate],
  );

  return (
    <>
      <Button
        onClick={handleOpen}
        classes={{
          root: classes.rapidButtonRoot,
          label: classes.rapidButtonLabel,
          contained: classes.rapidButtonContained,
        }}
        color="primary"
      >
        {date ? (
          moment(date).format(format)
        ) : (
          <div className={classes.label}>
            {label} <FontAwesomeIcon icon="chevron-down" className={classes.icon} />
          </div>
        )}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.content}>
          <DatePicker inline selected={date} onChange={handleChangeDate} maxDate={maxDate} />
          <Button
            onClick={handleClear}
            color="primary"
            classes={{
              root: classes.rapidButtonRoot,
              label: classes.rapidButtonLabel,
              contained: classes.rapidButtonContained,
            }}
          >
            Clear selection
          </Button>
        </div>
      </Menu>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  label: {
    margin: theme.spacing(0, 1),
  },
  icon: {
    marginLeft: theme.spacing(0.5),
    display: 'inline-block !important',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: '-7px 0', // Looks good
  },
  rapidButtonRoot: {
    ...(theme.rapidButton?.root || {}),
    padding: '0 !important',
    minWidth: 'fit-content !important',
  },
  rapidButtonLabel: theme.rapidButton?.label,
  rapidButtonContained: theme.rapidButton?.contained,
}));

export default DateFilter;
